import React, { useState } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import NewSubCategory from "./NewSubCategory";
import SubCategory from "./SubCategory";

const SubCategories = () => {
  const [activeButton, setActiveButton] = useState(false);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Sub Categories" />
          <div>
            <div className="d-flex justify-content-end mb-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setActiveButton(!activeButton);
                }}>
                {activeButton ? "Sub Category List" : "Add Sub Category"}
              </button>
            </div>
            {activeButton && (
              <div className="d-flex justify-content-end mb-3"></div>
            )}
          </div>

          {!activeButton && (
            <div className="">
              <SubCategory />
            </div>
          )}
          {activeButton && <NewSubCategory />}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SubCategories;
